import React from "react";
import { buildCollection, buildProperty } from "@firecms/core";
import { ChatContentPreview } from "./shared/chat_content_preview";
import { toolTypeEnumValues, videoSolutionStatusEnumValues } from "./shared/enums";

export type UserChatHistory = {
    historyId?: string;
    title?: string;
    createdAt?: Date;
    toolType?: keyof typeof toolTypeEnumValues;
    content?: unknown[];
    toolData?: Record<string, unknown>;
    solutionVideo?: {
        status?: keyof typeof videoSolutionStatusEnumValues;
        url?: string;
        sourceMessageIndex?: number;
        requestedAt?: Date;
        completedAt?: Date;
    };
};

/**
 * users/{uid}/history — sohbetler. Salt okunur; görsel dosyası yok, etiket var.
 */
export const userHistoryCollection = buildCollection<UserChatHistory>({
    id: "history",
    name: "Sohbetler",
    singularName: "Sohbet",
    path: "history",
    icon: "chat",
    titleProperty: "title",
    initialSort: ["createdAt", "desc"],
    permissions: {
        read: true,
        create: false,
        edit: false,
        delete: false,
    },
    properties: {
        title: buildProperty({
            name: "Başlık",
            dataType: "string",
            readOnly: true,
        }),
        toolType: buildProperty({
            name: "Araç",
            dataType: "string",
            enumValues: toolTypeEnumValues,
            readOnly: true,
        }),
        createdAt: buildProperty({
            name: "Oluşturulma",
            dataType: "date",
            mode: "date_time",
            readOnly: true,
        }),
        historyId: buildProperty({
            name: "Sohbet ID",
            dataType: "string",
            readOnly: true,
        }),
        content: buildProperty({
            name: "Mesajlar",
            dataType: "array",
            readOnly: true,
            Preview: ({ value }) => <ChatContentPreview value={value} />,
            of: {
                dataType: "map",
                properties: {
                    role: buildProperty({
                        name: "Rol",
                        dataType: "string",
                        readOnly: true,
                    }),
                    content: buildProperty({
                        name: "İçerik",
                        dataType: "array",
                        readOnly: true,
                    }),
                },
            },
        }),
        toolData: buildProperty({
            name: "Araç verisi",
            dataType: "map",
            keyValue: true,
            readOnly: true,
        }),
        solutionVideo: buildProperty({
            name: "Video çözüm",
            dataType: "map",
            readOnly: true,
            properties: {
                status: buildProperty({
                    name: "Durum",
                    dataType: "string",
                    enumValues: videoSolutionStatusEnumValues,
                    readOnly: true,
                }),
                url: buildProperty({
                    name: "URL",
                    dataType: "string",
                    url: true,
                    readOnly: true,
                }),
                sourceMessageIndex: buildProperty({
                    name: "Kaynak mesaj",
                    dataType: "number",
                    readOnly: true,
                }),
                requestedAt: buildProperty({
                    name: "İstek",
                    dataType: "date",
                    mode: "date_time",
                    readOnly: true,
                }),
                completedAt: buildProperty({
                    name: "Bitiş",
                    dataType: "date",
                    mode: "date_time",
                    readOnly: true,
                }),
            },
        }),
    },
});
